export enum EnumType{ 
    "iconAction",
    "link",
    "string",
    "icon"
}

export const ProjectHistoryColumns = [
    {
        name: "Nome do Projeto",
        id: "name"
    },
    {
        name: "Atividades Associadas",
        id: "activities"
    },
    {
        name: "Orçamento Estimado",
        id: "budget"
    }
    
];
